import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../../../../../../constants/common'
import { getQaSelector } from '../../../../../../../../utils/common'
import { BUTTON_HEIGHT_32 } from '../../../../../../../Button'
import { Checkbox } from '../../../../../../../Checkbox'
import { IntegerInput } from '../../../../../../../Input'
import { RadioGroup } from '../../../../../../../Radio'
import Text from '../../../../../../../Text'
import {
  MATCH_RULES_GATING_FIELD,
  MATCH_RULES_OCCUPANCY_MAX,
  MATCH_RULES_OCCUPANCY_MIN,
  MATCH_RULES_RANGE_SEPARATOR,
  QA_NAME_MATCH_RULES_GATING_VALUE,
} from '../../ListingProfileApplicantsMatchRules.constants'

import {
  getIsMatchRulesHouseholdCriterion,
  getIsMatchRulesPetsCriterion,
  getIsMatchRulesWbsCriterion,
  getMatchRulesPetsOptions,
} from './ListingProfileApplicantsMatchRulesModalGatingValue.utils'

import * as styles from './ListingProfileApplicantsMatchRulesModalGatingValue.module.css'

function ListingProfileApplicantsMatchRulesModalGatingValue({
  criterionKey,
  isReadOnly,
  values,
  onChange,
}) {
  const { t } = useTranslation()

  function handleChangeMinOccupancy(value) {
    onChange({ ...values, [MATCH_RULES_GATING_FIELD.minOccupancy]: value })
  }

  function handleChangeMaxOccupancy(value) {
    onChange({ ...values, [MATCH_RULES_GATING_FIELD.maxOccupancy]: value })
  }

  function handleChangePetsPolicy(value) {
    onChange({ ...values, [MATCH_RULES_GATING_FIELD.petsPolicy]: value })
  }

  function handleChangeWbsRequired() {
    onChange({
      ...values,
      [MATCH_RULES_GATING_FIELD.wbsRequired]:
        !values[MATCH_RULES_GATING_FIELD.wbsRequired],
    })
  }

  return (
    <span
      {...getQaSelector({ value: QA_NAME_MATCH_RULES_GATING_VALUE })}
      className={styles.ListingProfileApplicantsMatchRulesModalGatingValue}
    >
      {getIsMatchRulesHouseholdCriterion(criterionKey) ? (
        <>
          <span className={styles.range}>
            <IntegerInput
              disabled={isReadOnly}
              height={BUTTON_HEIGHT_32}
              max={MATCH_RULES_OCCUPANCY_MAX}
              min={MATCH_RULES_OCCUPANCY_MIN}
              placeholder={t('RentalPortal.MatchRulesOccupancyMinKey')}
              value={
                values[MATCH_RULES_GATING_FIELD.minOccupancy] ?? EMPTY_STRING
              }
              wrapperClassName={styles.number}
              onChange={handleChangeMinOccupancy}
            />
            <Text isSecondary className={styles.separator}>
              {MATCH_RULES_RANGE_SEPARATOR}
            </Text>
            <IntegerInput
              disabled={isReadOnly}
              height={BUTTON_HEIGHT_32}
              max={MATCH_RULES_OCCUPANCY_MAX}
              min={MATCH_RULES_OCCUPANCY_MIN}
              placeholder={t('RentalPortal.MatchRulesOccupancyMaxKey')}
              value={
                values[MATCH_RULES_GATING_FIELD.maxOccupancy] ?? EMPTY_STRING
              }
              wrapperClassName={styles.number}
              onChange={handleChangeMaxOccupancy}
            />
          </span>
        </>
      ) : null}
      {getIsMatchRulesPetsCriterion(criterionKey) ? (
        <RadioGroup
          className={styles.radioGroup}
          disabled={isReadOnly}
          options={getMatchRulesPetsOptions(t)}
          value={values[MATCH_RULES_GATING_FIELD.petsPolicy]}
          onChange={handleChangePetsPolicy}
        />
      ) : null}
      {getIsMatchRulesWbsCriterion(criterionKey) ? (
        <Checkbox
          checked={Boolean(values[MATCH_RULES_GATING_FIELD.wbsRequired])}
          disabled={isReadOnly}
          label={t('RentalPortal.MatchRulesWbsRequiredKey')}
          onChange={handleChangeWbsRequired}
        />
      ) : null}
    </span>
  )
}

export default ListingProfileApplicantsMatchRulesModalGatingValue
